import React from "react";
import { ISocieteDetails } from "../../../models/interfaces/ISociete";
//Styles:

interface IProps {
    MarqueResult: ISocieteDetails;
}



const MarqueBloc2: React.FC<IProps> = ({
  MarqueResult
}) => {
  return (
    <div className="card-body pae-form-container">
    <div className="col-sm-12 card pae-detail-pub-card" style={{ textAlign: 'left' , minHeight:'80px' , padding:"1%"}}>
           <h3>{MarqueResult?.Societe?.RaisonSociale}</h3>
    </div>
    </div>
    
  );
};

export default MarqueBloc2;
